import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { LinkedRadioButtonDropdownItem } from '../linked-radio-button-dropdown/linked-radio-button-dropdown.component';
import { buildStepItem } from './steps-navigation-helper';

@Component({
  selector: 'h3-steps-navigation',
  templateUrl: './steps-navigation.component.html',
  styleUrls: ['./steps-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StepsNavigationComponent {
  @Input({ required: true }) stepId!: number;
  steps$: Observable<LinkedRadioButtonDropdownItem[]>;

  constructor(store: TaskWorkspaceStore) {
    this.steps$ = store('project').$.pipe(
      filter(isDefined),
      map((project) =>
        project.steps.map((step) => buildStepItem(step, this.stepId)),
      ),
    );
  }
}
